export const PENDING_TURN_POLL_INTERVAL_MS = 5_000
export const PENDING_TURN_MAX_AGE_MS = 10 * 60_000
